import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetVendorBalancesQuery } from "../../../services/Reports";
import {
  getVendorBalancesRequest,
  getVendorBalancesFailure,
  getVendorBalancesSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allVendorBalances,
    isLoading: vendorBalancesLoading,
    isError: vendorBalancesError,
  } = useGetVendorBalancesQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.vendorBalancesPageNo,
    pageSize: state.vendorBalancesPageSize,
    fromDate: new Date(state.vendorBalancesFromDate).toLocaleDateString(),
    toDate: new Date(state.vendorBalancesToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (vendorBalancesLoading) {
      dispatch(getVendorBalancesRequest());
    }
    if (vendorBalancesError) {
      dispatch(getVendorBalancesFailure(vendorBalancesError));
    }
    if (allVendorBalances) {
      dispatch(
        getVendorBalancesSuccess({
          data: allVendorBalances.data.allVendorBalances[0].data || [],
          totalPages:
            allVendorBalances.data.allVendorBalances[0].metadata[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allVendorBalances,
    profileData,
    state.vendorBalancesFromDate,
    state.vendorBalancesToDate,
    state.vendorBalancesPageNo,
    state.vendorBalancesPageSize,
  ]);
  return <></>;
};
export default Content;
